import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Institution, MessageType, ToasterService, InstitutionType } from 'projects/shared-lib/src/public-api';
import { InstitutionService } from '../../core/services/institution.service';
import { SurveyUserService } from '../../core/services/survey-user.service';
import { LocalStorageUtil } from '../../shared/utils/local-storage.util';
import { ParagraphUtil } from '../../shared/utils/paragraph.util';

@Component({
  selector: 'app-household-search',
  templateUrl: './household-search.component.html',
  styleUrls: ['./household-search.component.css']
})
export class HouseholdSearchComponent implements OnInit {
  private errorMsg = "Please, complete all fields";
  public schoolDistrictType: number = InstitutionType.SCHOOL_DISTRICT;
  public searchByIdForm = null;
  public searchByLastNameForm = null;
  private userTypeName: string = "edu-family";
  @Input() public isEduFamily;
  @Output() searchByIdOrEmailEvent = new EventEmitter<string>();
  @Output() searchByLastNameEvent = new EventEmitter<{}>();
  @Output() searchBySurveyEmailEvent = new EventEmitter<{}>();


  constructor(
    public paragraphUtil: ParagraphUtil,
    public localStorageUtil: LocalStorageUtil,
    public institutionService: InstitutionService,
    public surveyUserService: SurveyUserService,
    private toasterService: ToasterService) {
      this.setFormGroups = this.setFormGroups.bind(this);
      const inst = this.localStorageUtil.getPreferedInstitution(this.userTypeName);
      this.setFormGroups(inst);
  }

  private setFormGroups(institution: Institution) {
    const defaultInstitutionId = institution?.id ? institution.id : "";

    this.searchByIdForm = new FormGroup({
      searchField: new FormControl("", [
        Validators.required,
        Validators.maxLength(160),
      ]),
    });

    this.searchByLastNameForm = new FormGroup({
      institutionId: new FormControl(defaultInstitutionId, Validators.required),
      facilityId: new FormControl("", Validators.required),
      lastName: new FormControl("", [
        Validators.required,
        Validators.maxLength(160),
      ]),
    });
  }

  ngOnInit(): void {
  }

  public searchByIdOrEmail() {
    if (this.searchByIdForm.valid) {
      this.searchByIdOrEmailEvent.emit(this.searchByIdForm.value.searchField);
    } else {
      this.toasterService.show(MessageType.VALIDATION, this. errorMsg);
      return;
    }
  }
  
  searchBySurveyEmail() {
    if (this.searchByIdForm.valid) {
      this.searchBySurveyEmailEvent.emit(this.searchByIdForm.value.searchField);
    } else {
      this.toasterService.show(MessageType.VALIDATION, this. errorMsg);
      return;
    }
  }

  public searchByLastname() {
    if (this.searchByLastNameForm.valid) {
      const data = {
        facilityId: this.searchByLastNameForm.value.facilityId,
        lastName: this.searchByLastNameForm.value.lastName,
      };
      this.searchByLastNameEvent.emit(data);
    } else {
      this.toasterService.show(MessageType.VALIDATION, this.errorMsg);
      return;
    }
  }

}
